/**
 * Tour steps — Incidents domain
 * Cubre: alerts (clave).
 */

import {
  Bell
} from '@phosphor-icons/react';

// ============ ALERT MANAGEMENT (clave en quick) ============
const alertManagementProspect = {
  id: 'alerts',
  title: 'Bandeja de alertas',
  description: 'Aquí llegan las alertas que requieren atención. Cada una con contexto, equipo afectado y acciones recomendadas. Sin saltar entre 5 herramientas.',
  icon: Bell,
  position: 'right',
  highlight: '[data-testid="nav-alerts"]',
  fallbackSelector: '[href="/alerts"]',
  mode: 'prospect',
  length: 'both',
  domain: 'incidents',
  videoFallback: null
};

const alertManagementOnboarding = {
  id: 'alerts',
  title: 'Alert Management',
  description: 'Cola unificada de alertas correlacionadas. Cada alerta lleva rule_id, severity (con enum parsing robusto), enrichment seed y técnica MITRE asociada. Soporta acknowledge, scope filter y bulk ops.',
  icon: Bell,
  position: 'right',
  highlight: '[data-testid="nav-alerts"]',
  fallbackSelector: '[href="/alerts"]',
  mode: 'onboarding',
  length: 'both',
  domain: 'incidents',
  videoFallback: null
};

// Retirada T5 (2026-10-13): los pasos de IncidentResponse y de los playbooks de
// HumanLayer resaltaban enlaces de pantallas retiradas, o sea pasos en blanco.
// Candado: backend/tests/test_retirado_t5_pantallas.py.
export const domainSteps = {
  prospect: {
    quick: [alertManagementProspect],
    full: [alertManagementProspect]
  },
  onboarding: {
    quick: [alertManagementOnboarding],
    full: [alertManagementOnboarding]
  }
};
